import { Route } from '@angular/router';
import { StatsLHComponent } from './stats-LH.component';
import { HistoriqueRouting } from './historique/historique-routing';
import { GestionRouting } from './gestion/gestion-routing';

export const StatsLHRouting: Route = {
  path: "stats-LH",
  component: StatsLHComponent,
  children: [
    { path: '', redirectTo: 'gestion', pathMatch: 'prefix' },
    GestionRouting,
    HistoriqueRouting
  ],
  data: {
    breadcrumb: "Linge Hebergement"
  }
}
